export default __webpack_public_path__ + "static/media/icons8-static-views-100.c613dff8.svg";